import { message } from 'antd'

export const copyToClipboard = (text: string) => {
    if (navigator.clipboard && window.isSecureContext) {
        navigator.clipboard.writeText(text).then(() => {
            message.success('Copied')
        }).catch(() => {
            fallbackCopy(text)
        })
    } else {
        fallbackCopy(text)
    }
}

const fallbackCopy = (text: string) => {
    const textarea = document.createElement('textarea')
    textarea.value = text
    textarea.style.position = 'fixed'
    textarea.style.left = '-9999px'
    document.body.appendChild(textarea)
    textarea.select()
    try {
        document.execCommand('copy')
        message.success('Copied')
    } catch {
        message.error('Copy failed')
    }
    document.body.removeChild(textarea)
}